import { useLang } from "@/lib/i18n";

export default function Marquee() {
  const { t } = useLang();
  const ITEMS = [t("marquee.1"), t("marquee.2"), t("marquee.3"), t("marquee.4"), t("marquee.5"), t("marquee.6")];
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative border-y border-white/10 bg-surface/40 py-5 overflow-hidden">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span className="font-serif italic text-xl md:text-2xl text-white/55 px-8 whitespace-nowrap">{item}</span>
                <span className="w-1.5 h-1.5 rotate-45 bg-gold/70 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
